import { FC } from 'react'
import { Select } from 'antd'
import FormItem from 'antd/es/form/FormItem'
import { CheckBoxLabel } from '@UI/CheckBox'
import InfoComp from '@pages/Admin/CRMSettings/components/InfoComp/InfoComp'
import { RequestCreateLeadPaymentLink } from '@/api/types/crm/crm.types'
import type { MonthlyCourseLinkPeriodUnit } from '../MonthlyCourseLinkFields/monthlyCourseLink.utils'
import StreamSelectTariffValueField from './StreamSelectTariffValueField'
import CreateLinkNumberInput, {
  createLinkNumberRuleTransform,
} from '../../CreateLinkNumberInput'
import spclasses from '../../../SetCourseClassDirectionModal/purchase.module.css'
import { CREATE_LINK_BLOCK_TARIFF_TYPES } from '../../tariffTypes'
import { withCreateLinkBlockTariffTypesHint } from '../../createLinkBlockInfoContent'

type FieldType = Omit<RequestCreateLeadPaymentLink, 'lead_funnel_id'>

type StreamCustomPeriodPeriodFieldsProps = {
  tariff: ICourseTariff
  isPeriodFixed: boolean
  periodUnit: MonthlyCourseLinkPeriodUnit
  periodValue: number
  onTogglePeriod: (checked?: boolean) => void
}

/**
 * Фиксация периода для stream_*:
 * — выкл: SelectTariffValue (чекбоксы/слайдер по настройкам тарифа), period_unit=null;
 * — вкл: period_unit month|day + value (как у month).
 */
const StreamCustomPeriodPeriodFields: FC<
  StreamCustomPeriodPeriodFieldsProps
> = ({ tariff, isPeriodFixed, periodUnit, onTogglePeriod }) => {
  return (
    <>
      <div className={spclasses.inputWithLabel}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <CheckBoxLabel
            type="button"
            value={isPeriodFixed}
            onClick={onTogglePeriod}
            label="Зафиксировать период оплаты"
            className={spclasses.checkboxWithLabel}
            style={{
              justifyContent: 'flex-start',
              paddingTop: '4px',
              paddingBottom: '4px',
              height: 'auto',
            }}
          />
          <InfoComp
            text={withCreateLinkBlockTariffTypesHint(
              'По умолчанию клиент при покупке сам выбирает, на какой период ему оплатить обучение. При включении данного чекбокса вы фиксируете период оплаты.',
              CREATE_LINK_BLOCK_TARIFF_TYPES.streamCustomPeriod,
            )}
          />
        </div>
      </div>

      {isPeriodFixed ? (
        <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
          <div className={spclasses.inputWithLabel}>
            <div className={spclasses.inputLabel}>Единица периода</div>
            <FormItem<FieldType> name="period_unit" noStyle>
              <Select
                className={spclasses.selectField}
                popupClassName={spclasses.selectFieldPopup}
                options={[
                  { value: 'month', label: 'Месяцы' },
                  { value: 'day', label: 'Дни' },
                ]}
              />
            </FormItem>
          </div>
          <div className={spclasses.inputWithLabel}>
            <FormItem<FieldType>
              name="value"
              rules={[
                {
                  required: true,
                  message: 'Укажите период оплаты',
                },
                {
                  type: 'number',
                  min: 1,
                  message: 'Период должен быть больше 0',
                  transform: createLinkNumberRuleTransform,
                },
              ]}
              noStyle
            >
              <CreateLinkNumberInput
                className={spclasses.input}
                title={
                  periodUnit === 'day'
                    ? 'Количество дней'
                    : 'Количество месяцев'
                }
                integer
                min={1}
                placeholder={1}
              />
            </FormItem>
          </div>
        </div>
      ) : (
        <div style={{ paddingLeft: '8px', paddingTop: '4px' }}>
          <FormItem<FieldType>
            name="value"
            rules={[
              {
                required: true,
                message: 'Укажите период оплаты',
              },
              {
                type: 'number',
                min: 1,
                message: 'Период должен быть больше 0',
                transform: (value) => Number(value),
              },
            ]}
            noStyle
          >
            <StreamSelectTariffValueField tariff={tariff} />
          </FormItem>
        </div>
      )}
    </>
  )
}

export default StreamCustomPeriodPeriodFields
